<template>
  <div
    class="video-item"
    :style="{ backgroundImage: `url(${item.pictureUrl})` }"
  >
    <div class="info-wrapper">
      <div class="info">
        <span class="time">{{ timeAgo(item.createTime) }}</span>
        <span class="play">播放{{ filterNum(item.clickSum) }}</span>
      </div>
      <div class="title text-line-2">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
import { timeAgo } from "@/utils/index";

export default {
  name: "VideoItem",
  props: {
    item: {
      type: Object,
      default: {},
    },
  },
  methods: {
    filterNum(val) {
      if (val && val > 10000) {
        return `${(val / 10000).toFixed(2)}w`;
      }
      return val;
    },
    timeAgo: timeAgo,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";

.video-item {
  margin-bottom: 3px;
  height: 200px;
  background: #fff;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .info-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.4) 5%, transparent);

    .info {
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 5px;
      right: 5px;
      color: #fff;

      .time {
        margin-right: 5px;
      }
    }

    .title {
      position: absolute;
      top: 60%;
      left: 5px;
      font-size: 14px;
      color: #fff;
    }
  }
}
</style>